import { useState } from 'react';
import SafeIcon from '../common/SafeIcon';
import { virtualFaqs } from '../data/virtualReceptionistPageContent';

const VirtualReceptionistFAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <section className="px-4 py-24 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-4xl">
        <div className="mb-12 text-center">
          <p className="mb-4 text-sm font-bold uppercase tracking-widest text-blue-400">FAQ</p>
          <h2 className="text-4xl font-extrabold text-white">Questions before switching from a live service</h2>
        </div>
        <div className="space-y-4">
          {virtualFaqs.map((faq, index) => (
            <div key={faq.question} className="overflow-hidden rounded-2xl border border-slate-800 bg-slate-900">
              <button type="button" onClick={() => setOpenIndex(openIndex === index ? null : index)} className="flex w-full items-center justify-between gap-5 px-6 py-5 text-left">
                <span className="text-lg font-semibold text-white">{faq.question}</span>
                <SafeIcon name={openIndex === index ? 'ChevronUp' : 'ChevronDown'} className="shrink-0 text-slate-400" />
              </button>
              {openIndex === index && <p className="px-6 pb-6 leading-relaxed text-slate-400">{faq.answer}</p>}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default VirtualReceptionistFAQ;